<template>
	<BaseSelect :options="options" @selected="(e) => walletStore.switchChain(e.symbol)">
		<template #select>
			<slot :chainDetails="walletStore.chainDetails"></slot>
		</template>
		<template #option="slotProps">
			<div class="chian-item">{{ slotProps.title }}</div>
		</template>
	</BaseSelect>
</template>

<script setup lang="ts">
import BaseSelect from '@/components/ui/BaseSelect.vue';
import { useWalletStore } from '@/stores/useWalletStore';
import { CHAINS } from '@/constants';

const walletStore = useWalletStore();

const options = Object.values(CHAINS);
</script>

<style scoped>
.chian-item {
	box-sizing: border-box;

	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 12px;
	gap: 16px;

	background: linear-gradient(
		83.45deg,
		rgba(2, 122, 255, 0.05) -1.65%,
		rgba(248, 254, 255, 0.05) 52.48%,
		rgba(2, 122, 255, 0.05) 104.15%
	);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 16px;

	cursor: pointer;
}

.button {
}
</style>
